import { useEffect, useState } from "react";
import Contact from "../components/Contact";
import Navigation from "../components/Navigation";
import useTitle from "@nooks/use-title";
import { Link } from "react-router-dom";
import { collection, query, orderBy, onSnapshot, deleteDoc, doc } from "firebase/firestore";
import { dbService } from "fbase";
import Pagination from "components/Pagenation";

function Review({userObj, isLoggedIn}){
    useTitle("캐리빌리 리뷰")
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const [reviewlist, setReviewlist] = useState([]);
    const getReviewlist = () => {
        const q = query(collection(dbService, "reviewlist"), orderBy("createdTime", "desc"));
        onSnapshot(q, (snapshot) => {
            const reviewArr = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setReviewlist(reviewArr);
        });
    }
    useEffect(()=>{
        getReviewlist()
    }, [])
    const onSubmit = (e) => {
        const searchInput = document.getElementById("searchInput");
        e.preventDefault();
        searchInput.blur();
        setReviewlist(reviewlist.filter((review) => review.nation.includes(search) || review.city.includes(search)))
    }

    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // 현재 페이지에 해당하는 리뷰 데이터 가져오기
    const currentReviews = reviewlist.slice(startIndex, endIndex);

    const [search, setSearch] = useState("");
    const onChange = (e) => {
        setCurrentPage(1)
        setSearch(e.target.value);
        getReviewlist()
    }

    useEffect(() => {
        window.scrollTo({
            top: document.getElementById('searchInput').offsetTop,
            behavior: 'smooth'
        });
    }, [currentPage]);

    const reviewTextRef = doc(dbService, "reviewlist", `reviewid`);

    const onDelete = async() => {
        const ok = window.confirm("리뷰를 삭제하시겠습니까?");
        if(ok){
            await deleteDoc(reviewTextRef);
        }
    }

    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <header className="masthead masthead-review">
                <div className="container">
                    <div className="masthead-heading text-uppercase">
                        Travel review
                    </div>
                    <form onSubmit={onSubmit}>
                        <input type="text" placeholder="여행 국가/도시 검색" value={search} onChange={onChange} className="searchInput" id="searchInput" />
                    </form>
                    <Link className="btn btn-primary btn-xl text-uppercase" to={process.env.PUBLIC_URL + "/reviewcreate"} style={{ textDecoration: 'none' }}>
                        리뷰 작성하기
                    </Link>
                </div>
            </header>
            <section className="page-section bg-light" id="reviewlist">
            {/* <h6>총 {reviewlist.length}개</h6> */}
            {reviewlist.length > 0 ?
                currentReviews.map((review) => (
                <div className="card px-3 pt-3" style={{maxWidth: "45rem", borderRadius: "1rem", marginBottom: "0.7rem"}} key={review.id}>
                    <div className="row mb-3">
                        <div className="col-6">
                            <div className="text-info">
                                <i className="fas fa-plane"></i>
                                &nbsp;{review.nation}_{review.city}
                            </div>
                        </div>
                        <div className="col-6 text-end">
                            <u>{review.term}</u>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-6 text-dark">
                            <h5>&nbsp;{review.name.replace(review.name[1], "*")}</h5>
                        </div>
                        <div className="col-6 text-end">
                            {review.age}/{review.gender}/{review.travelType}/총{review.days}일
                        </div>
                    </div>
                    <div className="text-dark">
                        <p>
                            꼭 먹어볼 음식 _ <strong>{review.food}</strong><br />
                            가볼 만한 곳 _ <strong>{review.place}</strong><br />
                            <hr />
                            <details>
                                <summary><i><strong>여행 후기 더보기</strong></i></summary>
                                &nbsp; 추천선물/기념품 _ <strong>{review.gift}</strong><br />
                                &nbsp; 짐 쌀 때 챙길 것 _ <strong>{review.pack}</strong><br />
                                <hr />
                                &nbsp; <strong>여행꿀팁</strong> _ {review.tips}<br />
                                &nbsp; <strong>비추천</strong> _ {review.notGood}
                            </details>
                        </p>
                    </div>
                </div>
                ))
            : (
                <div className="card px-3 pt-3" style={{maxWidth: "45rem", borderRadius: "1rem", marginBottom: "0.7rem"}}>
                    <div>
                        <div className="row mb-3">
                            <h5>아직 리뷰가 없습니다...</h5>
                        </div>
                    </div>
                </div>
            )}
            <div className="pagination-container">
            <Pagination
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                totalItems={reviewlist.length}
                onPageChange={setCurrentPage}
            />
            </div>
        </section>
        <Contact />
        </div>
    )
}

export default Review;